/*
 * @Author: yanghailong
 * @Date: 2023-08-23 09:07:36
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-03-27 11:26:01
 */
import Konva from "konva"
import { randomUUID, clamp } from "../utils/index.js"
import { GraphElement } from "../graph-element.js"
import { AddObjectRecord } from "../history/record.js"

class BusElement extends GraphElement {
  constructor(topology, x, y) {
    super(topology, 'bus', x, y, { width: 1400, height: 10, port: false })

    /**
     * 端口是否可拖拽
     * @type {boolean}
     */
    this.portDraggable = true

    /**
     * 用于保存下方的端口
     * @type {Konva.Circle[]}
     */
    this.portsDown = []

    /**
     * 用于保存上方的端口
     * @type {Konva.Circle[]}
     */
    this.portsUp = []
  }

  setup(name, attrs) {
    this.addArrow()
    this.addKeyshape(name, attrs)
    // onload
    // this.addPort(attrs.port)
    this.addLabel(attrs.text)
    this.addTransformer()
    this.executeLoadedHook(this.keyShape)


    if (this.__topology.editor) {
      this.bindGroupEvent()
    }
  }

  addKeyshape(name, attrs) {
    this.keyShape = new Konva.Rect({
      x: 0,
      y: 0,
      width: attrs.width,
      height: attrs.height,
      fill: '#C3CCFE',
      isKeyShape: true,
      name: `${name}-img`,
    })

    this.g.add(this.keyShape)

    if (this.__topology.editor) {
      this.bindNodeEvent(this.keyShape)
    }
  }

  addArrow() {
    this.arrow = new Konva.Arrow({
      x: 0,
      y: 0,
      points: [0, 0, 0, 30],
      pointerLength: 6,
      pointerWidth: 8,
      fill: '#000',
      stroke: '#000',
      opacity: 0.5,
      name: 'arrow',
      // draggable: true,
      visible: false,
      strokeWidth: 4,
    })
    this.g.add(this.arrow)
    if (this.__topology.editor) {
      this.bindArrowEvent(this.arrow)
    }
  }

  /**
   * 添加变换组件
   */
  addTransformer() {
    const { editor, storage } = this.__topology
    if (!editor) {
      return
    }
    let tr = this.layer.findOne('#bus-tr')

    if (!tr) {
      tr = new Konva.Transformer({
        rotateEnabled: false,
        padding: 5,
        enabledAnchors: ['middle-left', 'middle-right'],
        id: 'bus-tr'
      })
      this.layer.add(tr)
    }

    this.keyShape.on('click', () => {
      storage.select(this)
      tr.nodes([this.keyShape])
      this.layer.draw()
    })
    this.stage.on('click', (event) => {
      if (event.target === this.stage) {
        tr.nodes([])
        storage.deselect()
      }
    })
    this.keyShape.on('transformstart', () => {
      this.arrow.hide()
    })
    this.keyShape.on('transform', () => {
      this.updateLabelPosition()
    })
  }

  addLabel() {
    this.label = new Konva.Text({
      x: 0,
      y: -20,
      width: this.width,
      text: '母线',
      fill: '#000',
      align: 'right',
      verticalAlign: 'top',
      fontSize: 12,
    })
    this.g.add(this.label)
  }

  updateLabelPosition() {
    let x = this.keyShape.x()
    let w = this.keyShape.width() * this.keyShape.scale().x
    this.label.setAttr('x', x)
    this.label.setAttr('width', w)
    this.arrow.setX(w / 2)
    this.layer.batchDraw()
  }

  bindNodeEvent(node) {
    node.on('mouseenter', (event) => {
      this.arrow.show()
      this.arrow.setAttrs({
        opacity: 0.5,
      })
    })
    node.on('mousemove', (event) => {
      // log('mousemove')
      const pos = this.stage.getPointerPosition()
      this.arrow.setX(pos.x - this.x - this.stage.x())
    })
  }

  /**
   * 绑定组的事件，用于显示和隐藏端口
   */
  bindGroupEvent() {
    this.g.on('mouseover', (ev) => {
      this.showPort()
    })
    this.g.on('mouseout', (ev) => {
      this.hidePort()
    })
  }

  /**
   * 显示所有端口
   */
  showPort() {
    this.portsDown.forEach(p => p.show())
    this.portsUp.forEach(p => p.show())
  }

  /**
   * 隐藏所有端口
   */
  hidePort() {
    this.portsDown.forEach(p => p.hide())
    this.portsUp.forEach(p => p.hide())
  }

  /**
   * 母线下方箭头的事件处理函数
   * @param arrow
   */
  bindArrowEvent(arrow) {
    const { stage } = this
    let timer
    arrow.on('mouseover', () => {
      clearTimeout(timer)
      arrow.setAttrs({
        opacity: 1,
      })
      arrow.draw()
    })

    arrow.on('mouseout', () => {
      arrow.setAttrs({
        opacity: 0.5,
      })
      arrow.draw()
    })

    arrow.on('mousedown', () => {
      const pos = stage.getPointerPosition()
      let x = pos.x - stage.x()
      let y = this.g.getY() + this.keyShape.getHeight()
      const port = this.addDownPort(x)
      ///////////////////////////////////
      stage.fire('start-drawline', {
        port: port,
        pos: { x, y },
        sourceGraphElement: this,
      })
      this.g.draggable(false)
    })

    this.g.on('mouseleave', () => {
      timer = setTimeout(() => {
        arrow.hide()
      }, 500)
    })
  }

  /**
   * 在母线下方添加一个端口
   * @param {number} x 位置
   * @returns
   */
  addDownPort(x) {
    const el = this
    const port = new Konva.Circle({
      x: x - this.x,
      y: this.height,
      radius: this.portSize,
      fill: '#FFFFFF',
      stroke: '#00E8FF',
      strokeWidth: 1,
      name: 'port',
      dir: 'down',
      draggable: this.portDraggable,
      uuid: randomUUID(),
      dragDistance: 2,
      visible: false,
      dragBoundFunc(pos) {
        // 使用绝对坐标计算边界，避免画布平移(stage.position)后端口跑偏
        let x = el.keyShape.absolutePosition().x
        let w = el.keyShape.width() * el.keyShape.scale().x
        return {
          x: clamp(x, x + w, pos.x),
          y: this.absolutePosition().y
        }
      }
    })

    this.portsDown.push(port)
    this.g.add(port)


    this.bindPortEvent(port)
    return port
  }


  /**
   * 在母线上方添加一个端口
   * @param {number} x 位置
   * @returns
   */
  addUpPort(x) {
    const el = this
    const port = new Konva.Circle({
      x: x - this.x,
      y: 0,
      radius: this.portSize,
      fill: '#FFFFFF',
      stroke: '#00E8FF',
      strokeWidth: 1,
      name: 'port',
      dir: 'up',
      draggable: this.portDraggable,
      uuid: randomUUID(),
      dragDistance: 2,
      visible: false,
      dragBoundFunc(pos) {
        // 使用绝对坐标计算边界，避免画布平移(stage.position)后端口跑偏
        let x = el.keyShape.absolutePosition().x
        let w = el.keyShape.width() * el.keyShape.scale().x
        return {
          x: clamp(x, x + w, pos.x),
          y: this.absolutePosition().y
        }
      }
    })
    this.portsUp.push(port)
    this.g.add(port)

    this.bindPortEvent(port)
    return port
  }

  /**
   * 端口的事件处理程序
   * @param port
   */
  bindPortEvent(port) {
    // 右键删除
    port.on('contextmenu', (event) => {
      event.evt.preventDefault()
      if (this.getWithoutUsedPorts().includes(port)) {
        this.removePort(port)
      }
    })
  }

  /**
   * 删除端口
   * @param port 端口
   */
  removePort(port) {
    this.portsDown = this.portsDown.filter(p => p != port)
    this.portsUp = this.portsUp.filter(p => p != port)
    port.remove()
  }

  /**
   * 获取母线上还未连线的端口
   */
  getWithoutUsedPorts() {
    const edges = this.__topology.storage.graph.edges
    const usedPorts = new Set()

    // 使用 Set 来存储已使用的端口
    edges.forEach(edge => {
      if (edge.source.node === this) {
        usedPorts.add(edge.source.port)
      }
      if (edge.target.node === this) {
        usedPorts.add(edge.target.port)
      }
    })

    return [...this.portsDown, ...this.portsUp].filter(port => !usedPorts.has(port))
  }



  /**
   * 该元件的JSON描述
   */
  toJSON() {
    return {
      type: this.g.attrs.name,
      uuid: this.uuid,
      label: this.label.attrs.text,
      attrs: this.g.attrs,
      portsDown: this.portsDown.map(port => port.attrs),
      portsUp: this.portsUp.map(port => port.attrs),
      keyShapeAttrs: this.keyShape.attrs,
    }
  }
  
  
  /**复制JSON, 复制时去除端口
   * @override   
   */
  copyJSON() {
    return {
      ...this.toJSON(),
      uuid: randomUUID(),
      portsDown: [],
      portsUp: [],
      deviceIpAddress: null,
      deviceUUID: null,
    }
  }


  /**
   * 从JSON描述创建该元素
   * @param {import('../topology').Topology} topology 拓扑图对象
   * @param {object} node JSON数据
   * @param {Function} [complete] 创建完成时的回调函数
   */
  static fromJSON(topology, node, complete) {
    return new Promise((resolve) => {
      let elem = new this(topology, node.attrs.x, node.attrs.y)
      elem.keyShape.setAttrs(node.keyShapeAttrs)
      elem.updateLabelPosition()
      // set  uuid
      elem.uuid = node.uuid

      elem.label.setAttr('text', node.label)
      // set port uuid
      for (const down of node.portsDown) {
        let port = elem.addDownPort(down.x + elem.x)
        port.setAttr('uuid', down.uuid)
      }
      for (const up of node.portsUp) {
        let port = elem.addUpPort(up.x + elem.x)
        port.setAttr('uuid', up.uuid)
      }
      // add element
      topology.storage.addElement(elem)
      topology.history.push(new AddObjectRecord(topology, elem))

      complete && complete()
      resolve(elem)
    })

  }
}




export { BusElement }
